// يجعل كل مطبوعات المنصة تتسع في صفحة A4 عرضية واحدة قدر الإمكان:
// قبل الطباعة نقيس ارتفاع المحتوى بنفس أنماط الطباعة، ثم نصغّره (zoom) ليناسب الصفحة.
const MM = 96 / 25.4;
const PAGE_WIDTH_PX = (297 - 16) * MM; // A4 عرضي بهوامش 8مم
const PAGE_HEIGHT_PX = (210 - 16) * MM - 6; // هامش أمان صغير
const MAX_SCALE = 1.9; // أكبر تكبير للمطبوعات القصيرة
const UPSCALE = new Set(["printing-general-info"]);
const MIN_SCALE = 0.45; // أصغر تصغير مقبول؛ بعده يمتد المحتوى لصفحة ثانية

const TARGETS = {
  "printing-record-section": ".record-section-printable",
  "printing-record-form": ".single-record-print",
  "printing-student-records": ".student-records-print",
  "printing-council-record": ".council-print-page",
  "printing-principal-evaluation": ".principal-evaluation-print",
  "printing-general-info": ".general-info-printable",
};

let touched = [];
let probe = null;

function printRulesText() {
  let css = "";
  for (const sheet of Array.from(document.styleSheets)) {
    let rules;
    try { rules = sheet.cssRules; } catch { continue; }
    for (const rule of Array.from(rules || [])) {
      if (typeof CSSMediaRule !== "undefined" && rule instanceof CSSMediaRule && /print/i.test(rule.media.mediaText)) {
        for (const inner of Array.from(rule.cssRules)) {
          if (typeof CSSPageRule !== "undefined" && inner instanceof CSSPageRule) continue;
          css += `${inner.cssText}\n`;
        }
      }
    }
  }
  return css;
}

export function fitPrintToOnePage() {
  resetPrintFit();
  const classes = Array.from(document.body.classList).filter((name) => TARGETS[name]);
  if (!classes.length) return;
  probe = document.createElement("style");
  probe.textContent = printRulesText();
  document.body.appendChild(probe); // في آخر الصفحة ليتغلب على أنماط الشاشة المضمّنة في المكوّنات
  try {
    for (const name of classes) {
      for (const el of Array.from(document.querySelectorAll(TARGETS[name]))) {
        const saved = { width: el.style.cssText };
        const setWidth = (px) => ["width", "max-width", "min-width"].forEach((prop) => el.style.setProperty(prop, `${px}px`, "important"));
        // نقيس الارتفاع الفعلي بعد التصغير: عند التصغير يعاد توزيع النص على عرض أكبر
        // فيقصر المحتوى، لذلك نبحث عن أكبر نسبة تناسب الصفحة بدل حسابها مرة واحدة.
        const heightAt = (scale) => {
          el.style.zoom = String(scale);
          setWidth(PAGE_WIDTH_PX / scale);
          return el.getBoundingClientRect().height;
        };
        let best = null;
        if (UPSCALE.has(name) && heightAt(1) < PAGE_HEIGHT_PX * 0.97) {
          // محتوى قصير بخط صغير (مثل بطاقة بيانات المدرسة): نكبّره ليملأ الصفحة
          let low = 1;
          let high = MAX_SCALE;
          if (heightAt(high) <= PAGE_HEIGHT_PX) {
            best = high;
          } else {
            for (let i = 0; i < 12; i += 1) {
              const mid = (low + high) / 2;
              if (heightAt(mid) <= PAGE_HEIGHT_PX) low = mid; else high = mid;
            }
            best = low;
          }
        } else if (heightAt(1) > PAGE_HEIGHT_PX) {
          let low = MIN_SCALE;
          let high = 1;
          if (heightAt(low) > PAGE_HEIGHT_PX) {
            best = MIN_SCALE;
          } else {
            for (let i = 0; i < 12; i += 1) {
              const mid = (low + high) / 2;
              if (heightAt(mid) <= PAGE_HEIGHT_PX) low = mid; else high = mid;
            }
            best = low;
          }
        }
        el.style.cssText = saved.width;
        if (best !== null) {
          const finalScale = Number((best * 0.98).toFixed(3));
          el.style.zoom = String(finalScale);
          setWidth(PAGE_WIDTH_PX / finalScale);
          touched.push({ el, css: saved.width });
        }
      }
    }
  } finally {
    probe.remove();
    probe = null;
  }
}

export function resetPrintFit() {
  touched.forEach(({ el, css }) => { el.style.cssText = css; });
  touched = [];
  if (probe) { probe.remove(); probe = null; }
}
